export default {"src":"/_next/static/media/home-hand2.0eea7ac8.svg","height":713,"width":302,"blurWidth":0,"blurHeight":0};